import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { CRRACategorysModel } from 'src/Models/CRRACategoryModel';
import { CrraCategoryMasterService } from 'src/Services/crra-category-master.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-crra-category',
  templateUrl: './crra-category.component.html',
  styleUrls: ['./crra-category.component.css']
})
export class CrraCategoryComponent implements OnInit {

  stateCode: any;
  tokenKey: string;
  listofCategory: CRRACategorysModel[];
  listofCategoryExport: CRRACategorysModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  CategoryName: string;


  upDowCategoryNameCSS: string = '';
  upDowCategorySortCSS: string = '';
  upDowActiveCSS: string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;
  isState911: boolean = false;
  categoryId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly crraCategoryMaster: CrraCategoryMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofCategory = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'CategorySort';
    this.CategoryName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Categories');

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {

    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.isloading = true;
    this.GetCategory();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetCategory();
  }

  GetCategory() {
    this.isloading = true;
    this.listofCategory = [];
    if (this.CategoryName == "null") this.CategoryName = " ";
    this.crraCategoryMaster.GetAllCategory(this.tokenKey, this.PageNumber, this.PageSize, this.CategoryName, this.OrderBy, false).subscribe(
      data => {
        this.isloading = false;
        this.listofCategory = data['crracategory'];
        if (this.listofCategory != null) {
          if (this.listofCategory.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofCategory[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );

  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.CategoryName = $event.target.value;
    else
      this.CategoryName = 'null';

    this.GetCategory();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "CategoryName") {
        this.upDowCategoryNameCSS = 'fa fa-arrow-down';
        this.upDowCategorySortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "CategorySort") {
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = 'fa fa-arrow-down';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "CategoryName") {
        this.upDowCategoryNameCSS = 'fa fa-arrow-up';
        this.upDowCategorySortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "CategorySort") {
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = 'fa fa-arrow-up';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetCategory();
  }

  addCategory() {
    let navigation = '/admin/' + this.SelectedTool + '/category/manage';
    this.router.navigate([navigation]);
  }

  updateCategory(categoryId) {
    let navigation = '/admin/' + this.SelectedTool + '/category/manage/' + categoryId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.categoryId = id;
  }

  deleteCategory(categoryId) {
    this.isloading = true;
    this.crraCategoryMaster.DeleteCategory(this.tokenKey, categoryId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
            this.showMessage("Category Deleted successfully", 'Success', 'success')
        }
        this.GetCategory();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportCRRACategories() {
    this.isloading = true;
    this.listofCategoryExport = [];
    if (this.CategoryName == "null") this.CategoryName = " ";
    this.crraCategoryMaster.GetAllCategory(this.tokenKey, this.PageNumber, this.PageSize, this.CategoryName, this.OrderBy, true).subscribe(
      data => {
        this.listofCategoryExport = data['crracategory'];
        if (this.listofCategoryExport != null) {
          if (this.listofCategoryExport.length > 0) {
            setTimeout(() => {
              this.DownloadCRRACategories();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );

  }

  DownloadCRRACategories() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportCRRACategories';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportCRRACategories.xls");
  }

}
